import { breakpoints } from '@airwallex/global';
import { useState, useEffect } from 'react';

const useMediaQuery = (query: string) => {
  const [state, setState] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mql = window.matchMedia(query);
    let mounted = true;

    const onChange = () => {
      if (!mounted) {
        return;
      }
      setState(!!mql.matches);
    };

    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
    } else {
      mql.addListener(onChange);
    }
    setState(mql.matches);

    return () => {
      mounted = false;
      if (mql.removeEventListener) {
        mql.removeEventListener('change', onChange);
      } else {
        mql.removeListener(onChange);
      }
    };
  }, [query]);

  return state;
};

export const useDesktopSmall = (): boolean =>
  useMediaQuery(
    `(min-width: ${breakpoints.breakpointTokens.m + 1}px) and (max-width: ${breakpoints.breakpointTokens.l}px)`
  );
export const useTablet = (): boolean =>
  useMediaQuery(
    `(min-width: ${breakpoints.breakpointTokens.s + 1}px) and (max-width: ${breakpoints.breakpointTokens.m}px)`
  );
export const useDesktopStandard = (): boolean =>
  useMediaQuery(
    `(min-width: ${breakpoints.breakpointTokens.l + 1}px) and (max-width: ${breakpoints.breakpointTokens.xl}px)`
  );
export const useDesktopLarge = (): boolean => useMediaQuery(`(min-width: ${breakpoints.breakpointTokens.xl + 1}px)`);

export const useMobile = (): boolean => useMediaQuery(`(max-width: ${breakpoints.breakpointTokens.s}px)`);
export const useTabletOrMobile = (): boolean => useMediaQuery(`(max-width: ${breakpoints.breakpointTokens.m}px)`);
